<template>
	<div :class="['pins-item', {'pins-item--has-action': hasAction}]" @click="onAction_ClickHandler">
		<div class="pins-item__content">
			<slot></slot>
		</div>
		<div class="pins-item__footer">
			<slot name="footer"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'pins-item',
	props: {
		hasAction: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onAction_ClickHandler() {
			if (!this.hasAction)
				return
			this.$emit('click', {})
		}
	}
}
</script>

<style scoped>
.pins-item {
	border-radius: 3px;
	background: #fff;
	box-shadow: rgba(0,0,0,0.1) 1px 1px 5px;
}

.pins-item__content {
	width: 100%;
	height: 90px;
}
.pins-item.pins-item--has-action {
	cursor: pointer;
}
.pins-item.pins-item--has-action > .pins-item__content {
	transform-origin: left center;
	background-color: rgba(0,0,0,0);
	transform: translate(0, 0) scale(1, 1);
	transition: all 0.3s;
}
.pins-item.pins-item--has-action:hover > .pins-item__content {
	background-color: rgba(0,0,0,0.01);
	transform: translate(5px, 0) scale(1, 1);
}
.pins-item__footer {
	display: flex;
	background-color: rgba(0,0,0,0.02);
	height: 55px;
}
</style>


// WEBPACK FOOTER //
// src/modules/pins/PinsItem.vue